import BApp from "../../Modules/BApp";
import BDiaryDayEntries from "./BDiaryDayEntries";
import BDiaryDayEntry from "./BDiaryDayEntry";
import BDiaryDayForm from "./BDiaryDayForm";
import BDiaryDayMealForm from "./BDiaryDayMealForm";
import BDiaryDaySearch from "./BDiaryDaySearch";
import BDiaryDaySearchFactory from "./BDiaryDaySearchFactory";
import BDiaryDaySearchResult from "./BDiaryDaySearchResult";
import BDiaryDaySection from "./BDiaryDaySection";
import BDiaryDaySidebar from "./BDiaryDaySidebar";
import BForm from "../../modules/BForm";
import BModal from "../../Modules/BModal";
import BRequest from "../../Modules/BRequest";

export default class BDiaryDay
{
	constructor(el)
	{
		this.el = el;
		this.keyboardDelayTimeoutId = 0;
	}

	static selector = () => `.diary-day`;

	static initialize()
	{
		document.querySelectorAll(this.selector()).forEach(el => {
			const diaryDay = new this(el);
			diaryDay.refreshProgramMeals();
		});

		this.addEventListeners();
	}

	static addEventListeners()
	{
		/**************************************************************************
		 * Meal search input change.
		 */
		document.addEventListener("keyup", event => {
			if (event.target.matches(".profile-diary-search__query")) {
				clearTimeout(this.keyboardDelayTimeoutId);
				this.keyboardDelayTimeoutId = setTimeout(() => {
					const diaryDaySearch = new BDiaryDaySearch(event.target.closest(".profile-diary-search"));

					diaryDaySearch.search("term");
				}, 500);
			}
		});

		/**************************************************************************
		 * Meal search form, tag click.
		 */
		 document.addEventListener("change", event => {
			if (event.target.matches(".profile-diary-day-search .trend-tag")) {
				const diaryDaySearch = new BDiaryDaySearch(event.target.closest(".profile-diary-search"));

				diaryDaySearch.search("tags");
			}
		});

		/**************************************************************************
		 * Add any kind of meal button click.
		 */
		document.addEventListener("click", event => {
			if (event.target.matches(".diary-day__add-meal-button, .diary-day__add-meal-button *")) {
				event.preventDefault();

				const buttonEl = event.target.closest("button");
				const diaryDaySearch = BDiaryDaySearchFactory.construct(buttonEl.closest(".profile-diary-search"));
				const diaryDaySearchResult = new BDiaryDaySearchResult(buttonEl.closest("[data-id]"));

				diaryDaySearch.createEntry(diaryDaySearchResult);
			}
		});

		/**************************************************************************
		 * All forms submit.
		 */
		document.addEventListener("submit", function(event) {
			if (event.target.matches(`.profile-diary-day-form`)) {
				event.preventDefault();

				const form = new BDiaryDayForm(event.target);

				let checkedObjectIds = []
				try {
					let entries = new BDiaryDayEntries(form.el.closest(`.profile-diary-day-section`).querySelector(BDiaryDayEntries.selector()));
					checkedObjectIds = entries.getCheckedEntryIds();
				} catch (error) {
					// Nevermind.
				}

				const diaryDay = form.getDiaryDay();
				const method = form.getMethod();
				const url = form.getURL();
				const data = {
					...form.getData(),
					checkedObjectIds: checkedObjectIds,
					date: diaryDay.getDate(),
				};

				form.resetErrors();
				form.disable();

				BRequest.call(method, url, data).then(response => {
					if (response.data?.redirectUrl) {
						document.href = BApp.redirect(response.data.redirectUrl);
					}

					if (response.data?.templates?.entries || false) {
						diaryDay.getSection(form.el.dataset.section).setEntriesHtml(response.data.templates.entries);

						try {
							(new BDiaryDayEntries(diaryDay.getSection(form.el.dataset.section).el.querySelector(BDiaryDayEntries.selector()))).refreshActions();
						} catch (error) {
							console.error(error);
						}
					}

					if (response.data?.templates?.sidebar || false) {
						diaryDay.getSidebar().setHtml(response.data.templates.sidebar);
					}
					if (response.data?.templates?.mealsNutrients || false) {
						diaryDay.getMealsNutrientsContainer().setHtml(response.data.templates.mealsNutrients);
					}

					BModal.closeAll();

					form.el.reset();
					try {
						form.el.closest(`.dialog`).close()
					} catch (error) {
						// Nevermind.
					}
				}).catch(error => {
					form.setErrorResponse(error.response);
				}).finally(() => {
					form.enable();
					BApp.refresh();
				});
			}
		});

		/**************************************************************************
		 * Delete any kind of entry click.
		 */
		document.addEventListener("click", event => {
			if (event.target.matches(".profile-entry__delete-button, .profile-entry__delete-button *")) {
				event.preventDefault();

				const buttonEl = event.target.closest("button");
				const diaryDayEntry = new BDiaryDayEntry(buttonEl.closest(".profile-entry"));

				diaryDayEntry.delete();
			}
		});

		/**************************************************************************
		 * Meal form watched input change.
		 */
		document.addEventListener("change", function(event) {
			if (event.target.matches(".profile-diary-day-meal-form__watched-input")) {
				const diaryDayMealForm = new BDiaryDayMealForm(event.target.closest("form"));
				const form = diaryDayMealForm.getForm();
				const url = form.el.dataset.updateUrl;
				const data = {
					...form.getData(),
					scenario: event.target.dataset.scenario,
				};

				form.disable();

				BRequest.get(url, data).then(response => {
					form.enable();
					diaryDayMealForm.updateValues(response.data.values);
				}).finally(() => {
					form.enable();
				});
			}
		});

		/**************************************************************************
	 	 * Delete an entry within a meal.
		 */
		document.addEventListener("click", event => {
			if (event.target.matches(".profile-diary-day-meal-component__delete-button, .profile-diary-day-meal-component__delete-button *")) {
				event.preventDefault();

				const buttonEl = event.target.closest("button");
				const entryEl = buttonEl.closest("[data-id]");

				const diaryDayMealForm = new BDiaryDayMealForm(buttonEl.closest(".profile-diary-day-meal-form"));

				const url = buttonEl.dataset.deleteUrl;
				const data = {
					...diaryDayMealForm.getForm().getData(),
					objectId: parseInt(entryEl.dataset.id),
				}

				entryEl.remove();

				BRequest.call("DELETE", url, data).then(response => {
					diaryDayMealForm.updateValues(response.data.values);
				});

				if (diaryDayMealForm.getEntries().length < 1) {
					const diaryDayEntry = new BDiaryDayEntry(diaryDayMealForm.el.closest(".profile-entry--meal"));
					diaryDayEntry.delete();

					BModal.closeAll();
				}
			}
		});

		/****************************************************************************
		 * Create user ingredient button click.
		 */
		document.addEventListener("click", event => {
			if (event.target.matches(".diary-day__create-user-ingredient-button, .diary-day__create-user-ingredient-button *")) {
				event.preventDefault();

				const diaryDaySearch = new BDiaryDaySearch(event.target.closest(".profile-diary-search"));
				const diaryDay = diaryDaySearch.getDiaryDay();
				const form = new BForm(diaryDaySearch.el.closest("form"));

				const createUserIngredientFormEl = diaryDaySearch.el.querySelector(".user-ingredient-create-form");
				const url = createUserIngredientFormEl.dataset.createUrl;
				const data = {
					...form.getData(),
					date: form.el.closest("[data-date]").dataset.date,
					name: form.el.querySelector(".profile-diary-search__query").value,
				};

				form.resetErrors();
				form.disable();

				BRequest.post(url, data).then(response => {
					diaryDay.getSection("meals").setEntriesHtml(response.data.templates.entries);
					diaryDay.getSidebar().setHtml(response.data.templates.sidebar);
					diaryDay.getMealsNutrientsContainer().setHtml(response.data.templates.mealsNutrients);

					BModal.closeAll();
				}).catch(error => {
					form.setErrorResponse(error.response);
				}).finally(() => {
					form.enable();
					BApp.refresh();
				});
			}
		});

		/****************************************************************************
		 * Add program day meal button click.
		 */
		document.addEventListener("click", event => {
			if (event.target.matches(".profile-entry__add-program-day-meal-button, .profile-entry__add-program-day-meal-button *")) {
				event.preventDefault();

				const buttonEl = event.target.closest("button");
				const diaryDayEntry = new BDiaryDayEntry(buttonEl.closest(".profile-entry"));
				const diaryDay = diaryDayEntry.getDiaryDay();

				const url = diaryDayEntry.el.dataset.addUrl;
				const data = {
					date: diaryDay.getDate(),
					objectId: diaryDayEntry.getObjectId(),
				};

				diaryDayEntry.hide();
				diaryDayEntry.setProcessing();
				diaryDay.refreshProgramMeals();

				const preloader = diaryDay.getSection("meals").getPreloderTemplate().getElement();
				preloader.querySelector(".template-title").innerHTML = diaryDayEntry.el.dataset.title;

				diaryDay.getSection("meals").el.append(preloader);

				BRequest.post(url, data).then(response => {
					diaryDayEntry.unsetProcessing();
					diaryDay.getSection("meals").setEntriesHtml(response.data.templates.entries);
					diaryDay.getSidebar().setHtml(response.data.templates.sidebar);
					diaryDay.getMealsNutrientsContainer().setHtml(response.data.templates.mealsNutrients);
					diaryDay.refreshProgramMeals();
					preloader.remove();
				}).finally(() => {
					BApp.refresh();
				});
			}
		});
	}

	getDate()
	{
		return this.el.dataset.date;
	}

	getSection(key)
	{
		return new BDiaryDaySection(this.el.querySelector(`[data-section="${key}"]`));
	}

	getSidebar()
	{
		return new BDiaryDaySidebar(this.el.querySelector(".diary-day-sidebar"));
	}

	getMealsNutrientsContainer()
	{
		return new BDiaryDaySidebar(this.el.querySelector(".profile-diary-day-meals-nutrients-container"));
	}

	getProgramMealIds()
	{
		let ids = new Set;

		this.getSection("meals").getEntries().forEach(diaryDayEntry => {
			const id = parseInt(diaryDayEntry.el.dataset.programMealId);
			if (!isNaN(id)) {
				ids.add(id);
			}
		});

		this.getSection("program-day-meals").getEntries().forEach(diaryDayEntry => {
			if (diaryDayEntry.isProcessing()) {
				const id = parseInt(diaryDayEntry.el.dataset.id);
				if (!isNaN(id)) {
					ids.add(id);
				}
			}
		});

		return ids;
	}

	refreshProgramMeals()
	{
		const programMealInUseIds = this.getProgramMealIds();
		const diaryDaySection = this.getSection("program-day-meals");

		diaryDaySection.getEntries().forEach(diaryDayEntry => {
			if (programMealInUseIds.has(parseInt(diaryDayEntry.el.dataset.id))) {
				diaryDayEntry.hide();
			} else {
				diaryDayEntry.show();
			}
		});

		let visibleProgramMeals = 0;
		diaryDaySection.getEntries().forEach(diaryDayEntry => {
			if (!diaryDayEntry.el.hidden) {
				visibleProgramMeals++;
			}
		});

		if (visibleProgramMeals) {
			diaryDaySection.show();
		} else {
			diaryDaySection.hide();
		}
	}
}
